"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
const useStyles = () => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccTaskManagerShowGradeAndFeedbackStyle = (0, _react.useMemo)(() => {
    const ccTaskManagerShowGradeAndFeedback = (0, _css.css)({
      marginTop: pxToRem(20)
    });
    const ccTaskManagerShowGradeAndFeedbackAndDescription = (0, _css.css)({
      display: 'flex',
      flexDirection: isMobileView ? 'column' : 'row',
      flexWrap: 'nowrap',
      alignContent: 'center',
      alignItems: isMobileView ? 'stretch' : 'center',
      gap: '1rem'
    });
    return {
      ccTaskManagerShowGradeAndFeedback,
      ccTaskManagerShowGradeAndFeedbackAndDescription
    };
  }, [isMobileView, pxToRem]);
  return {
    'cc-TaskManager__show-grade-and-feedback': ccTaskManagerShowGradeAndFeedbackStyle.ccTaskManagerShowGradeAndFeedback,
    'cc-TaskManager__show-grade-and-feedback-and-description': ccTaskManagerShowGradeAndFeedbackStyle.ccTaskManagerShowGradeAndFeedbackAndDescription
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;